export const DISTANCE_UNIT = ["km", "miles"];
